module.exports = __webpack_public_path__ + "static/media/2016_conf_Building_Insanely_Great_Products.f9e07b78.png";